const wrapEvent = (handler, callback) => {
  if (!handler) return callback;
  return (event) => {
    handler(event);
    if (!event || !event.defaultPrevented) callback(event);
  };
};
const wrapEvents = (props, events) => Object.assign({}, ...Object.keys(events).map((e) => ({ [e]: wrapEvent(props[e], events[e]) })));
export {
  wrapEvent,
  wrapEvents
};
//# sourceMappingURL=wrapEvent.es.js.map
